<template>
    <div class='box'>
        <div class="titleBox">
            <h5>确定驳回？</h5>
        </div>

        <div class="textBox">
            <span class="spanBox">请输入驳回原因！</span>
            <textarea style="resize:none" v-model="DismissTheReason"></textarea>
        </div>

        <div class="btnBox">
            <van-button @click="abolishBtn">取消</van-button>
            <van-button @click="confirmBtn">确定</van-button>
        </div>
    </div>
</template>
<script>
import { InspectionPublish } from '@/api/page.js'
import { decideCheckSum } from '@/api/inspection'
import { getProcessNum } from '@/api/api.js' //获取流程数信息 3级流程/4级流程
import { Toast } from 'vant'
import {
    updateInfoStatus
} from '@/utils/inspectionFunctron.js'
export default {
    name: '',
    data() {
        return {
            DismissTheReason: '',    //驳回原因
            msg_item: null,
            orfourlevel: false //是否四级审核
        }
    },
    components: {

    },
    props: {
        rejectdata: {
            type: Object,

        },
        inspectionInfo: {
            type: Object
        }
    },
    methods: {
        // 取消
        abolishBtn() {
            this.$emit('cancelrejectBtn')
        },
        // 确定
        confirmBtn() {
            if (this.DismissTheReason != '') {
                let historyForm = JSON.parse(sessionStorage.getItem('nextHistoryForm'))
                historyForm.handleStepNote = this.DismissTheReason;  //驳回原因内容
                //获取当前点击进的列表列数据
                const msg_item = JSON.parse(
                    window.sessionStorage.getItem("processInstanceData")
                );
                const statusname = msg_item.name;

                console.log("statusname:", msg_item.name);
                //上一步（驳回）状态枚举
                const flowStatus_next = Object.freeze({//冻结对象 模拟ts的enum枚举
                    '4': "-4", // 校核 4 驳回后到 -4 校核驳回
                    '1': "-1", // 审核 1 驳回后到 -1 审核驳回
                    '2': "-2", // 签发 2 驳回后到 -2 签发驳回
                    '-2': "-1", // 签发驳回 到 审核驳回
                    '-1': this.orfourlevel ? "-4" : "-1", // 审核驳回 到 4级流程到 -4 校核驳回 3级流程到 -1 审核驳回
                    '-4': "-4"  // 校核驳回 
                });
                // historyForm.handleStepType = flowStatus_next[this.msg_item.processInstance.formVariables.flowStatus]//根据当前状态获取驳回后的状态
                // switch (statusname) {
                //     case "主管审核":
                //         historyForm.handleStepType = -1; //处理步骤id一级为-1
                //         break;
                //     case "检验员校核":
                //         historyForm.handleStepType = -4; //处理步骤id一级为-1
                //         break;
                //     case "总经理会签":
                //         historyForm.handleStepType = -2; //处理步骤id二级为-2
                //         break;
                //     default:
                //         Toast("暂未定义该状态");
                // }
                // return


                //updateInfoStatus是驳回接口传递的第二个值是提交后的变更状态，
                //对应的枚举在enum.js的TODO_FLOW_STATUS字
                updateInfoStatus(historyForm.jyjcInfoId, flowStatus_next[this.msg_item.processInstance.formVariables.flowStatus])

                //InspectionPublish是增加操作历史记录接口传递的historyForm.handleStepType决定了新增历史记录的状态， 
                // 对应的枚举在HistoryList.vue的HANDLE_STEP_TYPE字典中
                historyForm.handleStepType = flowStatus_next[this.msg_item.processInstance.formVariables.flowStatus]
                InspectionPublish(historyForm).then(() => {
                    //驳回上传数据
                    this.$emit('childBtn');
                })
            } else {
                Toast('驳回原因不能为空！')
            }
        }
    },
    async created() {
        this.msg_item = JSON.parse(window.sessionStorage.getItem("processInstanceData"));
        console.log("msg_item:", this.msg_item);

        if (this.msg_item) {
            // 获取流程级别
            try {
                const { data: { data: { nodes } } } = await getProcessNum({ processDefinitionId: this.msg_item.processInstance.processDefinitionId })
                switch (nodes) {
                    case 3:
                        this.orfourlevel = false
                        break;
                    case 4:
                        this.orfourlevel = true
                        break;
                    default:
                        Toast('当前流程配置异常，请联系管理员')
                        break;
                }
                console.log("nodes:", nodes);
            } catch (error) {
                console.error("获取流程配置失败:", error);
                Toast('获取流程配置失败,请稍后重试');
            }
        }
    },
    mounted() {
        this.DismissTheReason = this.rejectdata.infoResult
    }
}
</script>
<style scoped>
.box {
    display: flex;
    flex-wrap: wrap;
}

.titleBox {
    width: 100%;
    height: 10%;
    text-align: center;
    font-size: 1.125rem;
    color: #008BE6;
}

.titleBox h5 {
    width: 100%;
    height: 100%;
    margin: 0;
}

.textBox {
    width: 100%;
    height: 70%;

}

.textBox .spanBox {
    font-size: .75rem;
    color: #999;
    font-weight: 400;
    padding-left: 1.625rem;
}

.textBox textarea {
    width: 90%;
    height: 76%;
    display: block;
    margin: .5rem auto;
    border: none;
    border-radius: .625rem;
    background-color: #F8FAFB;
    padding: .625rem;
}

.btnBox {
    width: 100%;
    height: 20%;
    display: flex;
    justify-content: space-around;
    align-items: flex-end;
    margin-top: .8125rem;

}

.btnBox .van-button {
    width: 45%;
    height: 100%;
    border: none;
    border-radius: .625rem;
}
</style>
